import React, { forwardRef } from 'react';
import { Button } from '../Button';
import { theme } from '@contrast-security-inc/design-system-foundations';
import { css, cx } from '@emotion/css';
export const iconButtonStyles = css `
  background-color: ${theme.color.transparent};
  border-radius: 0;
  display: flex;
  justify-content: center;
  margin: 0;
  min-width: auto;
  padding: 0;

  div {
    display: flex;
  }

  &:focus:enabled {
    background-color: ${theme.color.transparent};
    outline: 1px solid ${theme.color.transparent};
  }

  &:focus-visible:enabled {
    background-color: ${theme.color.transparent};
    outline: 1px solid ${theme.color.turquoise70};
  }

  &:hover:enabled {
    background-color: ${theme.color.transparent};
    color: ${theme.color.turquoise90};
  }

  /* Overriding base button styles for svg */
  &:hover:enabled svg {
    fill: ${theme.color.turquoise90};
  }
`;
const primaryStyles = css `
  /* stylelint-disable-next-line no-descending-specificity */
  svg {
    fill: ${theme.color.turquoise70};
  }

  &:focus-visible:enabled svg,
  &:hover:enabled svg {
    fill: ${theme.color.turquoise90};
  }
`;
const secondaryStyles = css `
  /* stylelint-disable-next-line no-descending-specificity */
  svg {
    fill: ${theme.color.neutral80};
  }

  &:focus-visible:enabled svg,
  &:hover:enabled svg {
    fill: ${theme.color.neutral100};
  }
`;
const destructiveStyles = css `
  /* stylelint-disable-next-line no-descending-specificity */
  svg {
    fill: ${theme.color.red50};
  }

  &:focus-visible:enabled svg,
  &:hover:enabled svg {
    fill: ${theme.color.red70};
  }
`;
const specialDestructiveStyles = css `
  /* stylelint-disable-next-line no-descending-specificity */
  svg {
    fill: ${theme.color.neutral80};
  }

  &:focus-visible:enabled svg,
  &:hover:enabled svg {
    fill: ${theme.color.red70};
  }
`;
const getStyles = (variant, isDestructive) => {
    if (isDestructive) {
        return specialDestructiveStyles;
    }
    switch (variant) {
        case 'primary':
            return primaryStyles;
        case 'secondary':
            return secondaryStyles;
        case 'destructive':
            return destructiveStyles;
    }
};
export const IconButton = forwardRef(({ 'aria-label': ariaLabel, Icon, isDestructive = false, size = 'md', testId, variant = 'secondary', className, ...rest }, ref) => {
    if (!ariaLabel) {
        console.warn('An aria-label is required for accessibility');
    }
    if (!Icon) {
        console.warn('An Icon needs to be defined');
    }
    return (React.createElement(Button, { ...rest, "aria-label": ariaLabel, className: cx(iconButtonStyles, getStyles(variant, isDestructive), className, 'ds-icon-button'), ref: ref, testId: testId && `${testId}-icon-button` }, Icon && React.createElement(Icon, { size: size, testId: testId && `${testId}-icon-button-icon` })));
});
IconButton.displayName = 'IconButton';
